import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { CurrentWhiteLabelApplication } from '../utils/current-white-label-application';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { WhiteLabelApplicationService } from '../services/white-label-application.service';

@Injectable({ providedIn: 'root' })
export class WhitelabelGuard {
  constructor(
    private app: CurrentWhiteLabelApplication,
    private whiteLabelApplicationService: WhiteLabelApplicationService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ) {
    await this.whiteLabelApplicationService.waitUntilReady();

    if (this.app.isProjectApp()) {
      if (route.params.slug !== this.app.getProjectAppSlug()) {
        this.router.navigate(['project'], { replaceUrl: true });
        return false;
      } else if (isPlatformBrowser(this.platformId)) {
        const isOnProjectPage =
          window.location.href.split(this.app.getProjectAppSlug())[1] === '';
        if (isOnProjectPage) {
          this.router.navigate(['project'], { replaceUrl: true });
          return false;
        }
      }
    }

    return true;
  }
}
